/* eslint-disable */
import Api from "./Api";
import { toast } from "react-toast";
export default {

    async updateAccountInfo(payload) {
        const response = await Api().post(`api/trade/accounts`, payload);
        return response;
    },

    async getSlaveMastersAcc(type) {
        const response = await Api().get(`api/trade/accounts/${type}`);
        return response;
    },
    async updateAccounts(payload) {
        const response = await Api().put(`api/trade/account`, payload);
        return response;
    },
    async createMasterSlaveMapping(payload) {
        const response = await Api().post(`api/trade/account/slave-master`, payload);
        return response;
    },
    async getSlaveMapping(slave_id) {
        const response = await Api().get(`api/trade/account/get-slave-master/${slave_id}`);
        return response;
    },
    async updateDateRange(payload) {
        const response = await Api().post(`api/trade/account/update-date-range`, payload);
        return response;
    },

};